// FTEDN Team — Sidebar navigation (all admin features)
import { useAuth } from '../../hooks/useAuth';
import './Sidebar.css';

const NAV_ITEMS = [
  { icon: '📊', label: 'Dashboard', path: '/' },
  { icon: '📋', label: 'Waitlist', path: '/waitlist' },
  { icon: '👥', label: 'Creators', path: '/creators' },
  { icon: '🧪', label: 'Beta Programs', path: '/beta' },
  { icon: '🧴', label: 'Products', path: '/products' },
  { icon: '📦', label: 'Shipments', path: '/shipments' },
  { icon: '🧠', label: 'Feedback Intel', path: '/feedback' },
  { icon: '🗳️', label: 'Voting & Ideas', path: '/voting' },
  { icon: '💬', label: 'Community', path: '/community' },
  { icon: '✉️', label: 'Chat', path: '/chat' },
  { icon: '🛡️', label: 'Moderation', path: '/moderation' },
  { icon: '📱', label: 'SMS', path: '/sms' },
  { icon: '📧', label: 'Email', path: '/email' },
  { icon: '📈', label: 'Analytics', path: '/analytics' },
  { icon: '🏅', label: 'Ambassadors', path: '/ambassadors' },
  { icon: '🚩', label: 'Feature Flags', path: '/flags' },
  { icon: '🗄️', label: 'Backups', path: '/backups' },
];

export function Sidebar() {
  const { displayName, logout } = useAuth();
  const currentPath = window.location.pathname;

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <span className="sidebar-logo"><span className="logo-f">f</span><span className="logo-dot">.</span></span>
        <span className="sidebar-badge">team</span>
      </div>

      <nav className="sidebar-nav">
        {NAV_ITEMS.map((item) => (
          <a key={item.path} href={item.path}
            className={`sidebar-link ${currentPath === item.path ? 'active' : ''}`}>
            <span className="sidebar-link-icon">{item.icon}</span>
            <span className="sidebar-link-label">{item.label}</span>
          </a>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="sidebar-avatar">{displayName.charAt(0)}</div>
          <span className="sidebar-username">{displayName}</span>
        </div>
        <button className="sidebar-logout" onClick={logout} id="logout-btn">
          Sign Out
        </button>
      </div>
    </aside>
  );
}
